import { render, staticRenderFns } from "./_tabDrawing.vue?vue&type=template&id=82afadba&scoped=true&"
import script from "./_tabDrawing.vue?vue&type=script&lang=js&"
export * from "./_tabDrawing.vue?vue&type=script&lang=js&"
import style0 from "./_tabDrawing.vue?vue&type=style&index=0&id=82afadba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82afadba",
  null
  
)

export default component.exports